import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Post        from '@common/post/_post';

// -------------------------------------------------------


class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    
    // 存在しない場合
    if( data.report.list.length == 0 ){
      return (
        <div className="report-members">
          <div className="report-none">投稿がありません</div>
        </div>
      );
    }
    
    return (
      <div className="report-post-list">
        <div className="list-items">
          { data.report.list.map((d, key) => {
            
            let account = {};
            try { account = data.workflow.influencers[d.insta_user_id]; } catch(e) {}
            
            return <Post key={key} data={d} base={data} account={account} report={d} />
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;